<template>
	<div>
		<div class="patch-score-board" ref="board">
			<div class="title">
				<span>批量阅卷</span>
				<i class="iconfont iconzuidahua" v-if="isMini" @click="changeMini"></i>
				<i class="iconfont iconzuixiaohua" v-else @click="changeMini"></i>
			</div>
			<div v-if="isMini" class="mini-title">
				<el-button type="primary" style="color: white;background: #009688" size="medium" @click="patchSubmitScore">提交分数</el-button>
			</div>
			<div v-else>
				<ul class="tab-wrap">
					<li class="tab" :class="{ 'tab-active': tabActive === 'score' }" @click="changeTab('score')">打分</li>
					<li class="tab" :class="{ 'tab-active': tabActive === 'setting' }" @click="changeTab('setting')">配置</li>
				</ul>
				<div class="setting" v-if="tabActive === 'setting'">
					<el-form label-width="80px">
						<el-form-item label="批量份数:" prop="patchNums" model="patchForm">
							<el-input placeholder="请输入改卷分数" v-model="patchNums"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" style="background-color: #009688" size="medium" @click.native="handlePatchNum">确定</el-button>
						</el-form-item>
					</el-form>
				</div>
				<div class="score" v-if="tabActive === 'score'">
					<el-form>
						<el-form-item label-width="10px">
							<el-radio-group style="width: 100%" v-model="patchMeans" @change="changePatchMeans">
								<el-radio label="add" style="display: inline-block"
									>得 <i class="nums">{{ patchCurrentScore }}</i> 分</el-radio
								>
								<el-radio label="reduce" style="display: inline-block"
									>扣 <i class="nums">{{ patchCurrentScore }}</i> 分</el-radio
								>
							</el-radio-group>
						</el-form-item>
						<el-form-item label-width="110px">
							<el-button type="primary" style="background-color: #009688" size="medium" @click="patchSubmitScore">提交分数</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import dragMixin from '../../../mixin/drag-mixin'
import guideMixin from '../utils/guide-mixin'
export default {
	name: 'patch-score-board',
	mixins: [dragMixin, guideMixin],
	data() {
		return {
			//位置
			dragStartX: -25,
			dragStartY: 0,
			rotateDegree: 0,
			scaleState: 1,
			//tab 选择
			tabActive: 'score',
			//打分状态
			patchMeans: 'add',
			//默认批量份数
			patchNums: 1,
			//得分或者减分 分数
			patchCurrentScore: 0,
			//提交分数 是否mini
			isMini: false
		}
	},
	created() {
		this.watchCurrentEmit()
	},
	mounted() {
		this.$nextTick(() => {
			this.dragStartY = 45
			this.$refs['board'].style.transform = `translateX(${this.dragStartX}px) translateY(${this.dragStartY}px)`
		})
	},
	methods: {
		watchCurrentEmit() {
			this.eventBus.$on('patchCurrentScore', cb => (this.patchCurrentScore = cb))
		},
		// 切换tab
		changeTab(val) {
			this.tabActive = val
		},
		// 切换打分方式
		changePatchMeans(val) {
			this.patchMeans = val
			this.eventBus.$emit('changePatchMeans', val)
		},
		// 修改分数
		handlePatchNum() {
			if (Number(this.patchNums) <= 0 || this.patchNums.includes('.')) {
				this.$message.error('最小值为1,且不能为小数')
				return false
			}
			this.eventBus.$emit('setPatchNum', this.patchNums)
			this.tabActive = 'score'
		},
		// 批量提交
		patchSubmitScore() {
			this.eventBus.$emit('patchSubmitScore')
		},
		//切换方式  得分还是扣分
		changeMini() {
			this.isMini = !this.isMini
		}
	}
}
</script>

<style scoped lang="less">
.patch-score-board {
	width: 360px;
	background: white;
	position: absolute;
	right: 0;
	top: 0;
	cursor: move;
	box-sizing: border-box;
	border-radius: 8px;
	box-shadow: 0 0 10px rgb(185, 180, 180);
	z-index: 2;
	transform: translateX(-60px);
	.title {
		font-size: 18px;
		color: #ff7200;
		border-bottom: 1px dotted #ddd;
		width: 94%;
		margin-left: 3%;
		padding: 6px 0;
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		.iconzuidahua {
			color: black;
			font-size: 17px;
			&:hover {
				cursor: pointer;
			}
		}
		.iconzuixiaohua {
			color: black;
			font-weight: bolder;
			font-size: 23px;
			&:hover {
				cursor: pointer;
			}
		}
	}
	.mini-title {
		display: flex;
		justify-content: center;
		padding: 10px 0;
		box-sizing: border-box;
	}
	.tab-wrap {
		width: 94%;
		margin-left: 3%;
		height: 36px;
		display: flex;
		justify-content: space-around;
		border-bottom: 1px solid #ddd;
		.tab {
			flex: 1;
			text-align: center;
			line-height: 36px;
			&:hover {
				cursor: pointer;
			}
		}
		.tab-active {
			border-bottom: 2px solid red;
			box-sizing: border-box;
		}
	}
	.setting,
	.score {
		padding: 10px;
		box-sizing: border-box;
	}
	.nums {
		font-size: 26px;
		font-style: normal;
		font-weight: bolder;
		color: red;
	}
}
</style>
